<template>
  <div>
    <div class="box2ss flex-row">
      <el-row>
        <el-button @click="tabfun(0)" style="margin-right:22px;" :type="activeTab == 0 ? 'primary' : ''">全部</el-button>
        <el-button @click="tabfun(1)" style="margin-right:22px;" :type="activeTab == 1 ? 'primary' : ''">招聘中</el-button>
        <el-button @click="tabfun(2)" style="margin-right:22px;" :type="activeTab == 2 ? 'primary' : ''">暂未发布
        </el-button>
        <el-button @click="tabfun(3)" style="margin-right:22px;" :type="activeTab == 3 ? 'primary' : ''">停止招聘
        </el-button>
      </el-row>
    </div>
      <div style="float: right;" class="bd6s flex-col" @click="addfun()">
          <div class="mod4 flex-row justify-between" style="cursor:pointer;">
              <div class="outer3 flex-col"></div>
              <span class="info2">新增招聘岗位</span>
          </div>
      </div>

    <div class="page">
      <div class="page1">
        <div class="page1wrap infinite-list" style="cursor:pointer;overflow:auto" v-infinite-scroll="load1"  infinite-scroll-immediate="false">
          <div class="layer13 flex-col" v-for="(item, index) in loopData0" :key="index" @click="datafun(item.id)">
            <div class="main2 flex-col justify-between">
              <div class="ImageText4 flex-col">
                <div class="group2 flex-col justify-between">
                  <div class="block2 flex-col">
                    <div class="mod5 flex-row">
                      <div class="ImageText5 flex-col">
                        <div class="mod5 flex-row justify-between">
                          <div class="bd7 flex-col"></div>
                          <div class="TextGroup4 flex-col"><span class="word11">{{ item.name }}</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="TextGroup5 flex-col"><span class="info4">投递量：{{ item.deliveryCount === null ? 0 :
                      item.deliveryCount
                  }}</span></div>
                </div>
              </div>
              <div class="layer14 flex-row justify-between">
                <span class="word12">浏览量：{{ item.browseCount === null ? 0 : item.browseCount }}</span>
                <div class="info5" :style="{
                  color:
                    item.status === 'disable'
                      ? '#FFB000'
                      : item.status === 'enable'
                        ? '#2c86fd'
                        : '#FF5151',
                }">
                  {{
                      item.status === "disable"
                        ? "暂未发布"
                        : item.status === "enable"
                          ? "招聘中"
                          : "停止招聘"
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="nodata" v-if="loopData0.length == 0">
          <img src="../Candidate/assets/img/NoData.png">
          <p>暂无岗位信息</p>
          <div class="wrap3 flex-col" @click="addfun()">
            <div class="group1 flex-row justify-between">
              <div class="label3"></div>
              <span class="word9">新增招聘岗位</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import qs from 'qs';
export default {
  data() {
    return {
      resumeData: {}, //个人简历
      skillList: [], //技能列表
      page: 1,
      loopData0: [],
      activeTab: '',
    }
  },
  methods: {
    tabfun(val) {
      this.activeTab = val;
      if (val == 0) {
        this.activeTab = '';
      } else if (val == 1) { this.activeTab = 'enable' }
      else if (val == 2) { this.activeTab = 'disable' }
      else if (val == 3) { this.activeTab = 'stop' }
      this.Showfun();
    },
    addfun() {
      this.$router.push({ path: '/addtalent'})
      this.$store.state.stidx = 2;
    },
    datafun(id){
      this.$router.push({
        path: '/Talentils',
        query: {positionId:id}
      })
    },
    load1() {
      this.page++;
      this.Showfun(1);
    },
    Showfun(val) {
      this.$apiFun.companyPositionShow(qs.stringify({
        page: this.page,
        'condition[companyId_EQ]': localStorage.getItem("id"),
        'condition[status_EQ]': this.activeTab,
        pageSize: 24
      })).then((data) => {
        if (data.code === 200) {
          if(val == 1){
            this.loopData0 = this.loopData0.concat(data.data.list);
            this.loading.close();
          }else{
            this.loopData0 = data.data.list;
            this.loading.close();
          }
        }
      })
    }
  },
  mounted() {
    this.loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    this.Showfun();
  }
}
</script>
<style lang="less" scoped>
.page .bd1 .outer1 {
  height: 72vh !important;
}

.page .bd1 .outer1 .mod5 {
  width: 77% !important;
}

.page .bd1 .outer1 .mod8 {
  width: 22%;
}

.topimg {
  img {
    width: calc(100% - 40px);
    height: auto;
    margin: 20px;
    object-fit: cover;

  }
}

.page {
  width: calc(100% - 40px);
  margin: 20px;
  height: 80vh;

  .page1 {
    width: 100%;
    height: 80vh;
    border-radius: 4px;
    background: #FFFFFF;
    padding: 0px 20px 0 20px;

    .page1wrap {
      width: 100%;
      height: 80vh;

      .layer13 {
        float: left;
        margin-right: 20px;
      }
    }
  }

  .nodata {
    text-align: center;
    margin: 0% auto;
    padding-top: 15%;
  }

  .nodata img {
    width: 266px;
    height: 154px;
  }

  .nodata p {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #000000;
    line-height: 16px;
    text-align: center;
    padding-top: 14px;
  }

  .wrap3 {
    height: 30px;
    border-radius: 4px;
    background-color: rgba(62, 124, 255, 1);
    width: 118px;
    margin: 0 auto;
  }

  .group1 {
    width: 90px;
    height: 12px;
    margin: 9px 0 0 14px;
  }

  .label3 {
    width: 12px;
    height: 12px;
    background: url(./assets/img/add.png) 100% no-repeat;
  }

  .word9 {
    width: 72px;
    height: 12px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    white-space: nowrap;
    line-height: 12px;
    text-align: center;
  }
}

.box2ss {
  width: 960px;
  height: 36px;
  margin: 20px 0 20px 20px;

  .bd2s {
    background-color: rgba(215, 229, 255, 1);
    border-radius: 4px;
    height: 36px;
    width: 100px;

    .word7 {
      width: 28px;
      height: 14px;
      overflow-wrap: break-word;
      color: rgba(62, 124, 255, 1);
      font-size: 14px;
      font-family: PingFangSC-Medium;
      text-align: center;
      white-space: nowrap;
      line-height: 14px;
      display: block;
      margin: 11px 0 0 36px;
    }
  }

  .bd3s {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    height: 36px;
    margin-left: 20px;
    width: 100px;

    .txt1 {
      width: 42px;
      height: 14px;
      overflow-wrap: break-word;
      color: rgba(108, 110, 113, 1);
      font-size: 14px;
      text-align: center;
      white-space: nowrap;
      line-height: 14px;
      display: block;
      margin: 11px 0 0 29px;
    }
  }

  .bd4s {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    height: 36px;
    margin-left: 20px;
    width: 100px;

    .txt2 {
      width: 56px;
      height: 14px;
      overflow-wrap: break-word;
      color: rgba(108, 110, 113, 1);
      font-size: 14px;
      text-align: center;
      white-space: nowrap;
      line-height: 14px;
      display: block;
      margin: 11px 0 0 22px;
    }
  }

  .bd5s {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    height: 36px;
    margin-left: 20px;
    width: 100px;
    .word8 {
      width: 56px;
      height: 14px;
      overflow-wrap: break-word;
      color: rgba(108, 110, 113, 1);
      font-size: 14px;
      text-align: center;
      white-space: nowrap;
      line-height: 14px;
      display: block;
      margin: 11px 0 0 22px;
    }
  }
}

.bd6s {
    background-color: rgba(62, 124, 255, 1);
    border-radius: 4px;
    height: 30px;
    width: 118px;
    margin: -52px 20px 0 0;
    .mod4 {
        width: 90px;
        margin: 9px 0 0 14px;
        .outer3 {
            width: 12px;
            background: url(./assets/img/add.png) 100% no-repeat;
        }

        .info2 {
            width: 72px;
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 12px;
            text-align: center;
            white-space: nowrap;
            line-height: 12px;
            display: block;
        }
    }
}

.layer13 {
  background-color: rgba(247, 248, 251, 1);
  border-radius: 4px;
  height: 124px;
  margin-top: 20px;
  width: calc(35% - 41px);
  min-width: 280px;

  // width: 33%;
  &:nth-child(3n) {
    margin-right: 0 !important;
  }

  .main2 {
    width: 96%;
    height: 100px;
    margin: 8px 0 0 8px;

    .ImageText4 {
      height: 72px;
      width: 100%;

      .group2 {
        width: 100%;
        height: 72px;

        .block2 {
          background-color: rgba(255, 255, 255, 1);
          border-radius: 4px 4px 6px 6px;
          height: 42px;
          width: 100%;

          .mod5 {
            width: 114px;
            height: 26px;

            .ImageText5 {
              height: 26px;
              width: 114px;

              .mod5 {
                width: 114px;
                height: 26px;
                margin: 8px 0 0 12px;

                .bd7 {
                  width: 26px;
                  height: 26px;
                  background: url(./assets/img/Sffb.png) -2px -2px no-repeat;
                }

                .TextGroup4 {
                  height: 24px;
                  margin-top: 1px;
                  width: 80px;

                  .word11 {
                    width: 80px;
                    height: 24px;
                    overflow-wrap: break-word;
                    color: rgba(0, 0, 0, 1);
                    font-size: 16px;
                    font-family: PingFang-SC-Medium;
                    text-align: center;
                    white-space: nowrap;
                    line-height: 24px;
                    display: block;
                  }
                }
              }
            }

            .ImageText5 {
              height: 26px;
              width: 114px;

              .mod5 {
                width: 114px;
                height: 26px;
                margin: 8px 0 0 12px;

                .bd7 {
                  width: 26px;
                  height: 26px;
                  background: url(./assets/img/Sffb.png) -2px -2px no-repeat;
                }

                .TextGroup4 {
                  height: 24px;
                  margin-top: 1px;
                  width: 80px;

                  .word11 {
                    width: 40px;
                    height: 24px;
                    padding-left: 10px;
                    overflow-wrap: break-word;
                    color: rgba(0, 0, 0, 1);
                    font-size: 16px;
                    font-family: PingFang-SC-Medium;
                    text-align: center;
                    white-space: nowrap;
                    line-height: 24px;
                    display: block;
                  }
                }
              }
            }
          }
        }

        .TextGroup5 {
          height: 14px;
          width: 71px;
          margin: 16px 0 0 8px;

          .info4 {
            width: 71px;
            height: 14px;
            overflow-wrap: break-word;
            color: rgba(108, 110, 113, 1);
            font-size: 14px;
            text-align: center;
            white-space: nowrap;
            line-height: 14px;
            display: block;
          }
        }
      }
    }

    .layer14 {
      width: 96%;
      height: 16px;
      margin: 12px 0 0 8px;

      .word12 {
        width: 71px;
        height: 14px;
        overflow-wrap: break-word;
        color: rgba(108, 110, 113, 1);
        font-size: 14px;
        text-align: center;
        white-space: nowrap;
        line-height: 14px;
        margin-top: 2px;
        display: block;
      }

      .info5 {
        /*width: 64px;*/
        height: 16px;
        overflow-wrap: break-word;
        color: rgba(255, 77, 55, 1);
        font-size: 16px;
        font-family: PingFangSC-Medium;
        font-weight: bold;
        text-align: center;
        white-space: nowrap;
        line-height: 16px;
        display: block;
      }
    }
  }
}
</style>